<template>
  <div
    class="container-fluid mt-2 mb-2"
    style="border-radius: 5px; color: white; font-size: 1.4vw"
  >
    <!-- align-items-center = vert align center all boxes -->
    <!-- text-center = center align text in all boxes-->
    <div class="row text-center align-items-center bb-scoreboard-main-row">
      <!-- =============================================== -->
      <!-- label: arena statuses -->
      <div class="bb-scoreboard-arena-col">
        <div class="row p-2 m-1 bb-scoreboard-status-row">
          <div
            v-if="showLockStatus"
            class="m-1 p-2 bb-scoreboard-lock-status-value"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="arena_locked"></slot>
          </div>
          <div
            class="m-1 p-2 bb-scoreboard-status-label"
            :class="fill_txt()"
            style="background-color: #252526; border-radius: 5px"
          >
            Status
          </div>
          <div
            class="m-1 p-2 bb-scoreboard-status-value"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="arena_status"></slot>
          </div>
          <!-- arena combat sub-status  -->
          <div
            class="m-1 p-2 bb-scoreboard-sub-status-value"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="arena_sub_status"></slot>
          </div>
        </div>
      </div>
      <!-- =============================================== -->
      <!-- label: active combatants -->
      <div
        v-if="showCombatantCounts"
        class="bb-scoreboard-actives-col"
      >
        <div class="row rounded p-2 m-1 bb-scoreboard-actives-row">
          <div
            class="m-1 p-2 bb-scoreboard-actives-label"
            :class="fill_txt()"
            style="background-color: #252526; border-radius: 5px"
          >
            Actives
          </div>
          <!-- active combatants value -->
          <div
            class="m-1 p-2 bb-scoreboard-actives-value"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="active_combatants"></slot>
          </div>
          <!-- =============================================== -->
          <!-- label: inactive combatants -->
          <div
            class="m-1 p-2 bb-scoreboard-inactives-label"
            :class="fill_txt()"
            style="background-color: #252526; border-radius: 5px"
          >
            Inactives
          </div>
          <!-- inactive combatants value -->
          <div
            class="m-1 p-2 bb-scoreboard-inactives-value"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="inactive_combatants"></slot>
          </div>
        </div>
      </div>
      <!-- =============================================== -->
      <!-- label: viewing CR -->
      <div
        class="bb-scoreboard-view-col"
        :class="{ 'bb-scoreboard-view-hoverable': canPreviewExtraAttackOrigin }"
        @mouseenter="handleViewRoundHoverStart"
        @mouseleave="handleViewRoundHoverEnd"
      >
        <div class="row rounded p-2 m-1">
          <div
            class="col-md-8 m-1 p-2"
            :class="[
              fill_txt(),
              { 'bb-scoreboard-view-highlight': canPreviewExtraAttackOrigin },
            ]"
            style="
              background-color: #252526;
              border-radius: 5px;
              white-space: nowrap;
            "
          >
            View CR
          </div>
          <!-- view round value -->
          <div
            class="col-md-3 m-1 p-2"
            :class="{
              'bb-scoreboard-view-highlight': canPreviewExtraAttackOrigin,
            }"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="view_round"></slot>
          </div>
        </div>
      </div>
      <!-- =============================================== -->
      <!-- label: current CR -->
      <div class="bb-scoreboard-round-col">
        <div class="row rounded p-2 m-1">
          <div
            class="col-md-3 m-1 p-2"
            :class="fill_txt()"
            style="background-color: #252526; border-radius: 5px"
          >
            CR
          </div>
          <!-- combat round value -->
          <div
            class="col-md-2 m-1 p-2"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="combat_round"></slot>
          </div>
          <!-- =============================================== -->
          <!-- label: current CA -->
          <div
            class="col-md-3 m-1 p-2"
            :class="fill_txt()"
            style="background-color: #252526; border-radius: 5px"
          >
            CA
          </div>
          <!-- combat action value -->
          <div
            class="col-md-2 m-1 p-2"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="combat_action"></slot>
          </div>
        </div>
      </div>
      <!-- =============================================== -->
      <!-- label: unused action count -->
      <div
        v-if="current_round && showUnusedActionCount"
        class="bb-scoreboard-unused-col"
        :class="{ 'bb-scoreboard-unused-hoverable': canHighlightUnused }"
        @mouseenter="handleUnusedHoverStart"
        @mouseleave="handleUnusedHoverEnd"
      >
        <div
          class="row rounded p-2 m-1"
          :class="hideCell()"
        >
          <div
            class="col-md-8 m-1 p-2"
            :class="[
              fill_txt(),
              { 'bb-scoreboard-unused-active': canHighlightUnused },
            ]"
            style="background-color: #252526; border-radius: 5px"
          >
            Unused
          </div>
          <!-- unused action count value -->
          <div
            class="col-md-3 m-1 p-2"
            :class="hideCell()"
            style="background-color: #252526; border-radius: 5px"
          >
            <slot name="unused_action_count"></slot>
          </div>
        </div>
      </div>
      <!-- =============================================== -->
      <!-- label: which round -->
      <div
        v-else-if="showUnusedActionCount"
        class="bb-scoreboard-unused-col"
      >
        <div class="row rounded p-2 m-1">
          <div class="col-md-11 m-1 p-2 bb-scoreboard-which-round-value">
            <slot name="which_round"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScoreBoard',
  emits: [
    'unused-action-hover-start',
    'unused-action-hover-end',
    'view-round-hover-start',
    'view-round-hover-end',
  ],
  props: {
    view_round_value: {
      type: Number,
      required: true,
    },
    combat_round_value: {
      type: Number,
      required: true,
    },
    showCombatantCounts: {
      type: Boolean,
      default: true,
    },
    showUnusedActionCount: {
      type: Boolean,
      default: true,
    },
    showLockStatus: {
      type: Boolean,
      default: false,
    },
    currentActionCombatantsCount: {
      type: Number,
      default: 0,
    },
    extraAttacksMode: {
      type: Boolean,
      default: false,
    },
    unusedActionCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    current_round() {
      if (this.view_round_value == this.combat_round_value) {
        return true
      } else {
        return false
      }
    },
    canHighlightUnused() {
      return (
        this.current_round &&
        this.unusedActionCount > 0 &&
        this.unusedActionCount < this.currentActionCombatantsCount
      )
    },
    canPreviewExtraAttackOrigin() {
      return this.current_round && this.extraAttacksMode
    },
  },
  methods: {
    handleUnusedHoverStart() {
      if (!this.canHighlightUnused) {
        return
      }

      this.$emit('unused-action-hover-start')
    },
    handleUnusedHoverEnd() {
      if (!this.canHighlightUnused) {
        return
      }

      this.$emit('unused-action-hover-end')
    },
    handleViewRoundHoverStart() {
      if (!this.canPreviewExtraAttackOrigin) {
        return
      }

      this.$emit('view-round-hover-start')
    },
    handleViewRoundHoverEnd() {
      if (!this.canPreviewExtraAttackOrigin) {
        return
      }

      this.$emit('view-round-hover-end')
    },
    hideCell() {
      if (this.current_round) {
        return 'bb-el-visible'
      } else {
        return 'bb-el-hidden'
      }
    },
    fill_bg() {
      if (this.current_round) {
        return 'bb-cur-cell'
      } else if (this.view_round_value == 0) {
        return 'bb-cur-cell'
      } else {
        return 'bb-not-cur-cell'
      }
    },
    fill_txt() {
      if (this.view_round_value == this.combat_round_value) {
        return 'bb-cur-cell-txt'
      } else if (this.view_round_value == 0) {
        return 'bb-cur-cell-txt'
      } else {
        return 'bb-not-cur-cell-txt'
      }
    },
  },
}
</script>

<style scoped>
.bb-scoreboard-main-row {
  display: flex;
  flex-wrap: nowrap;
  min-width: 0;
}

.bb-scoreboard-arena-col {
  flex: 0 0 33%;
}

.bb-scoreboard-actives-col {
  flex: 0 0 22%;
}

.bb-scoreboard-view-col {
  flex: 0 0 12%;
}

.bb-scoreboard-round-col {
  flex: 0 0 18%;
}

.bb-scoreboard-unused-col {
  flex: 0 0 15%;
  min-width: 0;
}

.bb-scoreboard-status-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}

.bb-scoreboard-unused-active {
  color: #ffffff;
  text-decoration: underline;
}

.bb-scoreboard-unused-hoverable {
  cursor: pointer;
}

.bb-scoreboard-view-hoverable {
  cursor: pointer;
}

.bb-scoreboard-view-highlight {
  color: #ffffff;
  text-decoration: underline;
}

.bb-scoreboard-actives-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}

.bb-scoreboard-actives-label {
  flex: 0 0 22%;
}

.bb-scoreboard-actives-value {
  flex: 0 0 18%;
}

.bb-scoreboard-inactives-label {
  flex: 0 0 28%;
}

.bb-scoreboard-inactives-value {
  flex: 0 0 12%;
}

.bb-scoreboard-status-label {
  flex: 0 0 15%;
}

.bb-scoreboard-lock-status-value {
  flex: 0 0 22%;
  min-width: 0;
  white-space: nowrap;
}

.bb-scoreboard-status-value {
  flex: 0 0 18%;
  min-width: 0;
  white-space: nowrap;
}

.bb-scoreboard-sub-status-value {
  flex: 0 0 43%;
  min-width: 0;
  white-space: nowrap;
}

.bb-scoreboard-which-round-value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  padding-left: 0.35rem !important;
  font-size: 1.7vw;
  line-height: 1.15;
}
</style>
